export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";